import {
  createAllPptxComponentSchemas,
  createAllPptxComponentSchemasNarrowed
} from "./chunk-VN3IXWBP.js";

// src/schemas/component-union.ts
import { Type } from "@sinclair/typebox";
import { PptxSlideContentSchema } from "@json-to-office/shared/schemas/slide-content";
var PptxStandardComponentDefinitionSchema = Type.Union(
  [...createAllPptxComponentSchemas(Type.Any())],
  {
    discriminator: { propertyName: "name" },
    description: "Standard PPTX component definition with discriminated union"
  }
);
var PptxComponentDefinitionSchema = Type.Recursive(
  (This) => Type.Union([...createAllPptxComponentSchemasNarrowed(This)], {
    discriminator: { propertyName: "name" },
    description: "PPTX component definition with discriminated union"
  })
);

export {
  PptxStandardComponentDefinitionSchema,
  PptxComponentDefinitionSchema,
  PptxSlideContentSchema
};
//# sourceMappingURL=chunk-I5IWEE32.js.map